<!--
 * @Author:
 * @Description: 测点管理
-->
<template>
  <div class="measuring-point h-full">
    <el-row :gutter="10" class="h-full">
      <el-col :span="6" class="h-full">
        <el-card class="h-full">
          <div
            data-v-36a73dcc=""
            class="border-l-3 border-color-primary flex-1 pl-10px text-16px mb-10px"
          >
            时序测点目录
          </div>
          <el-row :gutter="10" class="mb-10px">
            <el-col :span="8">
              <el-select
                v-model="standardId"
                placeholder="选择标准"
                clearable
                @change="searchTreeData"
              >
                <el-option
                  v-for="(item, index) in standardList"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="8">
              <el-input
                v-model="forlderName"
                placeholder="搜索目录名称"
                size="mini"
                clearable
              ></el-input>
            </el-col>
            <el-col :span="4">
              <el-button type="primary" size="small" @click="searchTreeData">搜索</el-button>
            </el-col>
            <el-col :span="4">
              <el-button
                type="primary"
                size="small"
                @click="handleTreeData($event, 'createParentId')"
                >新增</el-button
              >
            </el-col>
          </el-row>
          <div class="flex-auto tree overflow-y-auto" style="height: calc(100% - 94px)">
            <el-tree
              v-loading="treeLoading"
              highlight-current
              :data="treeData"
              @node-click="handleDocNodeClick"
              :props="defaultTreeProps"
              :load="loadTreeData"
              node-key="id"
              ref="tree"
              class="h-full"
              :lazy="!isExpandAll"
              :default-expand-all="isExpandAll"
            >
              <div slot-scope="{ node, data }" class="node-item">
                <div class="custom-tree-node">
                  <p :title="node.label" class="flex-1 mr-15px truncate">
                    {{ node.label }}
                  </p>
                  <div class="mr-5px">
                    <el-dropdown>
                      <span class="el-dropdown-link">
                        <i class="iconfont icon-line-moreVertical text-14px font-bold"></i>
                      </span>
                      <el-dropdown-menu slot="dropdown">
                        <!-- 最多新增三级指标域 -->
                        <el-dropdown-item
                          :disabled="!$hasAccess('create') || node.level === 3"
                          @click.native="handleTreeData($event, 'create', data)"
                          >新增</el-dropdown-item
                        >
                        <el-dropdown-item
                          :disabled="!$hasAccess('update')"
                          @click.native="handleTreeData($event, 'update', data)"
                          >编辑</el-dropdown-item
                        >
                        <el-dropdown-item
                          :disabled="!$hasAccess('delete')"
                          @click.native="removeTreeData(data.id)"
                          >删除</el-dropdown-item
                        >
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                </div>
              </div>
            </el-tree>
          </div>
        </el-card>
      </el-col>
      <el-col :span="18" class="h-full">
        <el-card class="h-full">
          <el-row>
            <el-col :span="4" class="mr-10px">
              <!-- <el-input
                  class="w-full"
                  size="small"
                  v-model="searchData.dataSourceName"
                  placeholder="数据源名称"
                  clearable
                ></el-input> -->
              <el-select
                v-model="searchData.dataSource"
                placeholder="选择数据源"
                remote
                :remote-method="getDataSource"
                filterable
                clearable
                @clear="searchList"
              >
                <el-option
                  v-for="(item, index) in dataSourceList"
                  :key="index"
                  :label="item.dataSourceName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="4" class="mr-10px">
              <el-input
                class="w-full"
                placeholder="测点编码"
                size="small"
                v-model="searchData.kks"
                clearable
                @clear="searchList"
              ></el-input>
            </el-col>
            <el-col :span="4" class="mr-10px">
              <el-input
                class="w-full"
                placeholder="测点名称"
                size="small"
                v-model="searchData.pointName"
                @clear="searchList"
                clearable
              ></el-input>
            </el-col>
            <el-col :span="4" class="mr-10px">
              <el-select
                class="w-full"
                placeholder="测点类型"
                size="small"
                v-model="searchData.pointType"
                clearable
                @change="searchList"
              >
                <el-option
                  v-for="item in pointTypeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-col>
            <el-col :span="4" class="mr-10px">
              <el-select
                class="w-full"
                placeholder="测点状态"
                size="small"
                v-model="searchData.collectStatus"
                @change="searchList"
                clearable
              >
                <el-option
                  v-for="item in operationStatusList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option
              ></el-select>
            </el-col>
          </el-row>
          <div class="pt-10px flex">
            <el-button type="primary" @click="searchList" :disabled="!$hasAccess('read')"
              >搜索</el-button
            >
            <el-button @click="reset">重置</el-button>
            <el-button type="primary" @click="bingingShow" :disabled="!$hasAccess('create')"
              >测点绑定</el-button
            >
            <el-button type="primary" @click="openDialog('add')" :disabled="!$hasAccess('create')"
              >新增测点</el-button
            >
            <el-button @click="batchImport" :disabled="!$hasAccess('import')">导入</el-button>
            <el-button
              @click="batchExport"
              v-loading="exportLoading"
              :disabled="!$hasAccess('export')"
              >导出</el-button
            >
          </div>
          <el-table
            :data="tableData"
            class="mt-20px"
            height="calc(100% - 150px)"
            header-align="left"
            stripe
            border
            :row-key="getRowKey"
            @selection-change="handleSelectionChange"
            v-loading="tableLoading"
          >
            <el-table-column type="selection" width="55" :reserve-selection="true" />
            <el-table-column label="编号" width="50" type="index" show-overflow-tooltip />
            <el-table-column prop="standardCode" label="数据标准库" show-overflow-tooltip />
            <el-table-column prop="kks" label="测点编码(kks)" show-overflow-tooltip />
            <el-table-column prop="pointName" show-overflow-tooltip label="测点名称">
              <!-- <template v-slot:header>
                <span
                  >测点名称
                  <el-tooltip
                    effect="light"
                    :content="dataSourceDetail.dataSourceDirectRemark"
                    placement="top-start"
                    ><span
                      style="color: rgba(247, 208, 0, 1)"
                      class="iconfont icon-line-circleQuestion text-14px"
                    ></span> </el-tooltip
                ></span>
              </template> -->
            </el-table-column>

            <el-table-column prop="address" label="地址" show-overflow-tooltip>
              <template slot-scope="scope">
                {{ scope.row.address ? scope.row.address : '-' }}
              </template>
            </el-table-column>
            <el-table-column width="80px" prop="pointType" label="测点类型" show-overflow-tooltip>
              <template slot-scope="scope">
                {{ scope.row.pointType === 0 ? '开关量' : '模拟量' }}
              </template>
            </el-table-column>
            <el-table-column prop="pointDescription" label="测点描述" show-overflow-tooltip />

            <el-table-column prop="unit" label="单位" show-overflow-tooltip />
            <el-table-column prop="machineSet" label="机组" show-overflow-tooltip />
            <el-table-column prop="collectStatus" width="80px" label="测点状态">
              <template slot-scope="scope">
                <el-switch
                  :disabled="!$hasAccess('update')"
                  @change="changePointState(scope.row)"
                  :active-value="1"
                  :inactive-value="0"
                  :value="scope.row.collectStatus"
                ></el-switch>
              </template>
            </el-table-column>
            <el-table-column prop="createdTime" label="创建时间" show-overflow-tooltip />
            <el-table-column prop="status" label="操作" width="150">
              <template #default="scope">
                <el-button
                  size="mini"
                  @click="openDialog('detail', scope.row)"
                  :disabled="!$hasAccess('read')"
                  >详情</el-button
                >
                <el-button
                  size="mini"
                  @click="openDialog('edit', scope.row)"
                  :disabled="!$hasAccess('update')"
                  >编辑</el-button
                >
                <!-- <el-button
                  size="mini"
                  @click="deleteTag(scope.row)"
                  :disabled="!$hasAccess('delete')"
                  >删除</el-button
                > -->
              </template>
            </el-table-column>
          </el-table>
          <div class="flex justify-end">
            <el-pagination
              class="my-20px"
              background
              @size-change="searchList"
              @current-change="getMearsuringList"
              :current-page.sync="pageNo"
              layout="total, sizes, prev, pager, next, jumper"
              :page-size.sync="pageSize"
              :total="total"
              :page-sizes="[15, 30, 50, 100]"
              :pager-count="5"
            >
            </el-pagination>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <com-dialog
      v-if="addDialogShow"
      :addDialogShow="addDialogShow"
      :dataSourceDirectName="dataSourceDirectName"
      :folderId="currentTreeNode.id"
      :standardId="standardId"
      :dataSourceConfigId="dataSourceConfigId"
      :dialogTitle="dialogTitle"
      :measuringPointDetail="measuringPointDetail"
      :handlerType="handlerType"
      @addDialogClose="addDialogClose"
      @refreshList="searchList"
    />
    <binding-dialog
      v-if="bindingDialogShow"
      :bindingDialogShow="bindingDialogShow"
      :bindingSourceDetail="bindingSourceDetail"
      :standardId="standardId"
      :folderId="currentTreeNode.id"
      @bindingDialogClose="bindingDialogClose"
      @refreshList="searchList"
    />
    <wiz-upload-file
      v-dialogDrag
      @refreshList="getMearsuringList()"
      v-if="showUploadExcelDialog"
      :uploadFileProps="uploadFileProps"
      @exportTemplate="exportTemplate"
      @importTemplate="importTemplate"
      @exportResults="exportResults"
    ></wiz-upload-file>
    <!-- 新增和编辑指标域 -->
    <el-dialog
      v-if="showTreeDialog"
      :close-on-click-modal="false"
      :title="treeDialogTitle"
      :visible.sync="showTreeDialog"
      class="small-dialog"
      v-dialogDrag
      :before-close="closeTreeDialog"
    >
      <el-form label-width="150px" :model="treeForm" :rules="treeRules" ref="treeForm">
        <el-form-item label="标准" prop="standardId">
          <el-select v-model="treeForm.standardId" placeholder="选择标准">
            <el-option v-for="(item, index) in standardList" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="目录名称" prop="name">
          <el-input placeholder="目录名称" v-model="treeForm.name" clearable> </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" :loading="addTreeLoading" @click="saveTreeData">保存</el-button>
        <el-button @click="closeTreeDialog">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { wizUploadFile } from '@wiz-core/compts'
import fnMixins from '@/assets/js/fnMixins'
import { find, isNil, forIn, cloneDeep, isEmpty } from 'lodash'
import ComDialog from './components/comDialog'
import BindingDialog from './components/bindingDialog'
import selectStandardId from '../../components/selectStandardId'
import MeasuringPointService from '@/services/MeasuringPointService'
import StandardManagementService from '@/services/common/StandardManagementService'
import configManagementService from '@/services/configManagementService'
import VirtualTree from '@/components/virtualScrollTree/tree'
import _ from 'lodash'

export default {
  name: 'measuring-point',
  components: {
    ComDialog,
    BindingDialog,
    wizUploadFile,
    selectStandardId,
    VirtualTree,
  },
  mixins: [fnMixins],
  computed: {
    dataSourceDetail() {
      const detail = find(this.dataSourceList, ['id', this.searchData.dataSource])
      console.log('detail', detail)
      if (!isNil(detail)) {
        return {
          ...detail,
          dataSourceDirectName: detail.protocolTypeName,
          dataSourceConfigId: detail.id,
        }
      }
      return {
        dataSourceDirectName: null,
        dataSourceConfigId: null,
        dataSourceDirectRemark: '请选择数据源',
      }
    },
    // dataSourceDirectName() {
    //   if (this.handlerType === 'add') {
    //     return this.dataSourceDetail?.dataSourceDirectName?.toLowerCase()
    //   }
    //   const detail = find(this.dataSourceList, ['id', this.measuringPointDetail.dataSourceConfigId])
    //   return detail.protocolTypeName.toLowerCase()
    // },
  },
  data() {
    return {
      showUploadExcelDialog: false,
      pageNo: 1,
      pageSize: 15,
      total: 0,
      tableLoading: false,
      addDialogShow: false,
      bindingDialogShow: false,
      exportLoading: false,
      dialogTitle: null,
      handlerType: null,
      searchData: {},
      uploadFileProps: {
        visible: false, // 是否开启弹窗
        active: 0, // 目前状态页面1为下载模板 2为上传模板 3为完成
        btnLoading: false, // 按钮加载状态
        isTestAndVerify: true, // 是否开启校验格式
        type: ['xls', 'xlsx'], // 检验文件格式，为数组可传多种同类型格式
        successCount: 0, // 上传成功条数
        failureCount: 0, // 上传失败条数
        resultFile: '', // 导入结果id，下载导入结果时需要使用
      },
      dataSourceDirectName: null,
      dataSourceConfigId: null,
      bindingSourceDetail: {},
      measuringPointDetail: {},
      dataSourceList: [], // 数据源列表
      tableChecked: [],
      pointTypeList: [
        {
          id: 0,
          name: '开关量',
        },
        {
          id: 1,
          name: '模拟量',
        },
      ], // 测点类型列表
      operationStatusList: [
        {
          id: 0,
          name: '停止',
        },
        {
          id: 1,
          name: '启动',
        },
      ], // 测点状态列表
      tableData: [],
      treeData: [],
      defaultTreeProps: {
        children: 'child',
        label: 'name',
        isLeaf: 'isLeaf',
      },
      isShowTooltip: false,
      heightObj: {
        minHeight: '30rem',
        maxHeight: '45rem',
        isZoom: false,
      },
      treeLoading: false,
      isExpandAll: false,
      showTreeDialog: false,
      treeDialogTitle: null,
      treeForm: {},
      treeRules: {
        name: [{ required: true, message: '请输入目录名称', trigger: 'blur' }],
        standardId: [{ required: true, message: '请选择标准', trigger: 'change' }],
      },
      addTreeLoading: false,
      standardList: [],
      standardId: '',
      forlderName: '',
      currentTreeNode: {},
    }
  },
  async created() {
    this.getDataSource()
    if (this.$route.query && this.$route.query.name) {
      this.searchData.itemid = this.$route.query.name
      // this.searchData.dataSource = null
    }
    if (this.$route.query && this.$route.query.state) {
      this.searchData.operationStatus = this.$route.query.state
      // this.searchData.dataSource = null
    }
    this.getMearsuringList()
    this.searchTreeData()
    this.getStandardList()
  },
  methods: {
    deleteTag(row) {
      this.$confirm('确认要删除该测点么?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const res = await MeasuringPointService.deleteTags([row.id])
        console.log(res, 'res-111')
        if (res.code === 0) {
          this.$message.success('删除成功')
          this.searchList()
        }
      })
    },
    updateStandardId(val) {
      this.standardId = val
      // this.getOpcDaList()
    },
    // 懒加载子节点
    async loadTreeData(node, resolve) {
      this.isExpandAll = false
      console.log('node', node)
      if (node.level > 0) {
        const res = await MeasuringPointService.getFolders({
          standardId: this.standardId,
          parentId: node.data.id,
          name: this.forlderName,
        })
        if (res && res.code === 0 && !_.isEmpty(res.data)) {
          const resData = _.map(res.data, (item) => {
            item.children = []
            return item
          })
          // this.handleLazyLoad(node.data.id, this.treeData, resData)
          return resolve(resData)
        }
      }
      return resolve([])
    },
    // 搜索指标域
    async searchTreeData() {
      this.treeLoading = true
      const res = await MeasuringPointService.getFolders({
        parentId: '00000000-0000-0000-0000-000000000000',
        standardId: this.standardId,
        name: this.forlderName,
      })
      this.treeLoading = false
      if (res && res.code === 0 && !_.isEmpty(res.data)) {
        this.treeData = _.map(res.data, (item) => {
          item.children = []
          return item
        })
        this.currentTreeNode = {}
        // this.$nextTick(() => {
        //   this.$refs.tree.setCurrentKey(this.currentTreeNode.id)
        //   // this.findList()
        // })
      }
    },
    // 点击指标域域节点
    handleDocNodeClick(data) {
      this.currentTreeNode = data
      this.$nextTick(() => {
        this.$refs.tree.setCurrentKey(this.currentTreeNode.id)
        // this.findList()
        this.searchParams = {
          folderId: data.id,
        }
        this.getMearsuringList()
      })
    },
    // 处理树节点
    handleTreeData(e, type, data) {
      if (e && e.stopPropagation) {
        e.stopPropagation()
      } else {
        e.cancelBubble = true
      }
      if (type === 'createParentId') {
        // 新增父节点
        this.treeDialogTitle = '新增测点目录'
        this.showTreeDialog = true
      } else if (type === 'create') {
        // 新增子节点
        this.treeDialogTitle = '新增测点目录'
        this.showTreeDialog = true
        this.treeForm.parentId = data.id
      } else if (type === 'update') {
        this.treeDialogTitle = '编辑测点目录'
        this.treeForm = _.cloneDeep(data)
        this.showTreeDialog = true
      }
      this.treeForm.standardId = this.standardId
    },
    removeTreeData(id) {
      this.$confirm('确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const res = await MeasuringPointService.deleteFolder([id])
        if (res && res.code === 0) {
          this.$message.success('删除成功')
          this.searchTreeData()
        }
      })
    },
    // 新增和编辑指标域
    saveTreeData() {
      this.$refs.treeForm.validate(async (valid) => {
        console.log('this.treeForm', this.treeForm)
        if (valid) {
          this.addTreeLoading = true
          if (this.treeDialogTitle === '新增测点目录') {
            const res = await MeasuringPointService.addFolder([this.treeForm])
            if (res && res.code === 0) {
              this.$message.success('新增成功')
            }
          } else {
            const res = await MeasuringPointService.updateFolder(this.treeForm)
            if (res && res.code === 0) {
              this.$message.success('修改成功')
            }
          }
          this.addTreeLoading = false
          this.closeTreeDialog()
          this.searchTreeData()
        }
      })
    },
    // 关闭指标域弹窗
    closeTreeDialog() {
      this.$refs.treeForm.resetFields()
      this.treeForm = this.$options.data().treeForm
      this.showTreeDialog = false
    },
    // 获取标准库
    async getStandardList() {
      console.log('3434s')
      const res = await StandardManagementService.getList()
      if (res && res.data && res.code === 0) {
        this.standardList = _.map(res.data, (item) => {
          return {
            name: item.name,
            code: item.code,
            id: item.id,
          }
        })
        this.$nextTick(() => {
          this.standardId = this.standardList[0].id
          this.searchTreeData()
        })
      }
    },
    async exportTemplate() {
      const res = await MeasuringPointService.downloadExportTemplate({
        protocolType: this.dataSourceDetail.protocolType,
      })
      if (res) {
        this.downLoadExcel('测点管理导入模板.xlsx', res)
      }
    },
    async importTemplate(file) {
      const formData = new FormData()
      formData.append('file', file)
      formData.append('dataSourceConfigId', this.dataSourceDetail.dataSourceConfigId)
      formData.append('protocolType', this.dataSourceDetail.protocolType)
      const res = await MeasuringPointService.import(formData)
      if (res) {
        this.uploadFileProps.active = 2
        this.downLoadBlob({
          name: '测点导入结果.xlsx',
          data: res,
        })
      }
      this.uploadFileProps.btnLoading = false
    },
    // 下载导入结果
    async exportResults() {
      const [err, res] = await MeasuringPointService.downImportInfoUsingGET({
        id: this.uploadFileProps.resultFile,
      })
      if (!err) {
        this.downLoadBlob({
          name: '测点导入结果.xlsx',
          data: res,
        })
      }
    },
    search() {
      this.pageNo = 1
      this.searchParams = {
        ...this.searchData,
        standardId: this.standardId,
        folderId: this.currentTreeNode ? this.currentTreeNode?.id || undefined : undefined,
        dataSourceConfigId: this.dataSourceDetail.dataSourceConfigId,
      }
      this.getMearsuringList()
    },
    reset() {
      this.pageNo = 1
      this.searchData = this.$options.data().searchData
      this.searchParams = {}
      this.getMearsuringList()
    },
    /**
     * @description: 拿取数据源名称列表
     * @param {*}
     * @return {*}
     */
    async getDataSource(dataSourceName) {
      const params = {
        standardId: this.standardId,
        maxResultCount: 100,
        skipCount: 0,
        dataSourceName: dataSourceName,
      }
      const res = await configManagementService.getCollectDataSourceConfigList(params)
      if (res && res.code === 0) {
        this.dataSourceList = res.data
      }
    },
    async getMearsuringList() {
      this.tableLoading = true
      const query = {
        ...this.searchParams,
        skipCount: (this.pageNo - 1) * this.pageSize,
        maxResultCount: this.pageSize,
      }
      const res = await MeasuringPointService.getList(query)
      if (res && res.code === 0) {
        this.tableData = res.data
        this.total = res.totalCount
      }
      this.tableLoading = false
    },
    bingingShow() {
      if (!this.currentTreeNode || !this.currentTreeNode?.id) {
        this.$message.warning('请先选择测点目录')
        return
      }
      if (!this.standardId) {
        this.$message.warning('请先选择标准库')
        return
      }
      if (isNil(this.dataSourceDetail.dataSourceDirectName)) {
        this.$message.warning('请选择数据源')
      } else if (
        !isNil(this.dataSourceDetail.dataSourceDirectName) &&
        (this.dataSourceDetail.dataSourceDirectName.toLowerCase() === 'opc-da' ||
          this.dataSourceDetail.dataSourceDirectName.toLowerCase() === 'opc-ua')
      ) {
        this.bindingSourceDetail = this.dataSourceDetail
        this.bindingDialogShow = true
      } else {
        this.$message.warning('当前数据源不支持测点绑定')
      }
    },
    openDialog(type, row) {
      let dialogTitle = null
      let dataSourceDirectName = null
      let dataSourceConfigId = null
      // 根据类型做不同参数处理
      if (type === 'add') {
        if (isNil(this.searchData.dataSource) || this.searchData.dataSource === '') {
          this.$message.warning('请先选择数据源')
          return
        }
        if (!this.currentTreeNode || !this.currentTreeNode?.id) {
          this.$message.warning('请先选择测点目录')
          return
        }
        if (!this.standardId) {
          this.$message.warning('请先选择标准库')
          return
        }
        dialogTitle = '新增测点'
        dataSourceDirectName = this.dataSourceDetail.dataSourceDirectName.toLowerCase()
        console.log(this.dataSourceDetail, 'dataSourceDetail')
        dataSourceConfigId = this.dataSourceDetail.dataSourceConfigId
      } else {
        dialogTitle = type === 'edit' ? '编辑测点' : '测点详情'
        const tempDetail = find(this.dataSourceList, ['dataSourceConfigId', row.dataSourceConfigId])
        if (!isNil(tempDetail)) {
          dataSourceDirectName = tempDetail.dataSourceDirectName.toLowerCase()
        } else {
          dataSourceDirectName = 'opc-da'
        }
        dataSourceConfigId = row.dataSourceConfigId
        this.measuringPointDetail = row
      }
      // 确定dialog参数，打开弹窗
      this.handlerType = type
      this.dataSourceDirectName = dataSourceDirectName // 用于判断当前弹窗展示内容
      this.dataSourceConfigId = dataSourceConfigId
      this.dialogTitle = dialogTitle
      this.addDialogShow = true
    },
    addDialogClose() {
      this.addDialogShow = false
      this.handlerType = null
      this.dataSourceDirectName = null
      this.dataSourceConfigId = null
      this.dialogTitle = null
      this.measuringPointDetail = this.$options.data().measuringPointDetail
    },
    bindingDialogClose() {
      this.bindingDialogShow = false
      this.bindingSourceDetail = this.$options.data().bindingSourceDetail
    },
    async changePointState(row) {
      const res = await MeasuringPointService.switchPointStatus([row.id])
      if (res && res.code == 0) {
        // this.getMearsuringList()
        row.collectStatus = row.collectStatus == 0 ? 1 : 0
        this.$message.success('状态更新成功')
      }
    },
    getRowKey(row) {
      return row.id
    },
    searchList() {
      this.pageNo = 1
      this.searchParams = {
        ...this.searchData,
        standardId: this.standardId || undefined,
        folderId: this.currentTreeNode ? this.currentTreeNode?.id : undefined,
        dataSourceConfigId: this.dataSourceDetail.dataSourceConfigId || undefined,
      }
      this.getMearsuringList()
    },
    handleSelectionChange(val) {
      this.tableChecked = val
    },
    async batchExport() {
      if (isNil(this.searchData.dataSource) || this.searchData.dataSource === '') {
        this.$message.warning('请先选择数据源')
        return
      }
      const query = {
        pointIds: _.isEmpty(this.tableChecked) ? [] : _.map(this.tableChecked, 'id'),
        standardId: this.standardId,
        dataSourceConfigId: this.dataSourceDetail.dataSourceConfigId,
        protocolType: this.dataSourceDetail.protocolType,
      }
      this.exportLoading = true
      const res = await MeasuringPointService.export(query)
      if (res) {
        this.downLoadBlob({
          name: '测点导出结果.xlsx',
          data: res,
        })
        this.$message.success('导出完成')
      }
      this.exportLoading = false
    },
    batchImport() {
      if (isNil(this.searchData.dataSource) || this.searchData.dataSource === '') {
        this.$message.warning('请先选择数据源')
        return
      }
      this.showUploadExcelDialog = true
      this.uploadFileProps.visible = true
      this.uploadFileProps.active = 0
    },
    afterImport() {
      this.searchList()
      this.uploadFileProps.visible = false
    },
  },
}
</script>

<style scoped lang="scss">

.measuring-point {
  ::v-deep .el-card__body {
    height: 100%;
  }
}
.tree {
  height: calc(100% - 74px);
  ::v-deep .el-tree-node__content {
    height: 35px;
    .node-item {
      width: calc(100% - 24px);
      .custom-tree-node {
        display: flex;
        align-items: center;
        font-size: 14px;
      }
    }
  }
}

</style>
